import { InjectionToken } from "@angular/core";

export const LIST_MANAGER_DYNAMIC_TEMPLATES = new InjectionToken<string>('LIST_MANAGER_DYNAMIC_TEMPLATE');
